import { CaptionText, FlexColumn, FlexRow, SubtitleText } from '@make-software/cspr-design';
import styled from 'styled-components';

export const ModalContainer = styled(FlexColumn)<{
  size?: 'small' | 'medium' | 'large';
}>(({ theme, size }) => {
  const getWidth = () => {
    switch (size) {
      case 'small':
        return ['100%', '376px'];
      case 'large':
        return ['100%', '600px'];
      case 'medium':
      default:
        return ['100%', '528px'];
    }
  };

  const getMaxHeigh = () => {
    switch (size) {
      case 'small':
        return ['100%', '704px'];
      case 'large':
        return ['100%', 'auto'];
      case 'medium':
      default:
        return ['100%', 'auto'];
    }
  };

  return theme.withMedia({
    width: getWidth(),
    background: theme.styleguideColors.backgroundPrimary,
    borderColor: theme.styleguideColors.backgroundPrimary,
    overflowY: 'auto',
    height: 'unset',
    maxHeight: getMaxHeigh(),
  });
});

export const ModalHeaderContainer = styled(FlexRow)<{
  marginBottom?: string;
}>(({ theme, marginBottom }) =>
  theme.withMedia({
    marginBottom: marginBottom ? marginBottom : '0',
  })
);

export const CloseButton = styled.div(() => ({
  cursor: 'pointer',
  padding: '0 10px',
}));

export const BackButton = styled.div(() => ({
  cursor: 'pointer',
}));

export const ModalButtonsContainer = styled(FlexRow)(({ theme }) =>
  theme.withMedia({
    marginTop: ['24px', '32px'],
    flexDirection: ['column', 'row', 'row'],
    gap: ['10px', '10px'],
  })
);

export const ModalTitle = styled(SubtitleText)(({ theme }) =>
  theme.withMedia({
    fontWeight: [600, 600, 700],
    fontSize: ['20px', '24px', '24px'],
  })
);

export const ModalDescription = styled(CaptionText)<{ isCsprName?: boolean }>(({ theme, isCsprName }) =>
  theme.withMedia({
    fontWeight: 400,
    fontSize: ['16px', '14px', '14px'],
    color: isCsprName ? theme.styleguideColors.contentBlue : theme.styleguideColors.contentSecondary,
  })
);

export const centerModalStyles = {
  left: '50%',
  right: 'auto',
  bottom: 'auto',
  borderRadius: 'none',
  padding: '24px 24px 0',
  top: '50%',
  transform: 'translate(-50%, -50%)',

  // Prevent clipping on short windows: constrain + scroll inside the modal.
  maxHeight: 'calc(100dvh - 48px)',
  overflow: 'auto',
};

export const getMobileModalStyles = {
  left: '0',
  right: '0',
  bottom: '0',
  top: 'auto',
  width: '100%',
  height: 'auto',
  maxHeight: 'calc(100vh - 110px)',
  padding: '20px 16px 0',
  transform: 'none',
  borderRadius: '0',
  boxShadow: 'none',
  overflow: 'auto',
};
